"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePopoverControl = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = require("react");
var usePopoverControl = function usePopoverControl(inputRef) {
  var _useState = (0, _react.useState)(1),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    key = _useState2[0],
    setKey = _useState2[1];
  var close = (0, _react.useCallback)(function () {
    setKey(function (oldKey) {
      return oldKey + 1;
    });
  }, []);
  var reopen = (0, _react.useCallback)(function () {
    close();
    setTimeout(function () {
      inputRef.current.focus();
    }, 0);
  }, [inputRef, close]);
  return {
    close: close,
    reopen: reopen,
    key: key
  };
};
exports.usePopoverControl = usePopoverControl;